import { put, select, takeEvery } from 'redux-saga/effects'
import { TRIGGER_DEBUG_POPUP, MESSAGE_TYPES, popupTriggerer } from '../constants'
import { message, jackpotMessageClosed } from '../actions'


/**
 * Creates a list of sagas that should be run on specific events.
 */
export default function* watchFetchData() {
  yield takeEvery(TRIGGER_DEBUG_POPUP, onTriggerDebugPopup)
}

/**
 * Saga that triggers different popups manuall.
 */
function* onTriggerDebugPopup(action) {
  const { args } = action

  switch (args.type) {
    case popupTriggerer.NORMAL_ERROR: {
      yield put(message({
        type: MESSAGE_TYPES.ERROR,
        errorCode: '100',
        message: 'Normal error message',
      }))
      break
    }
    case popupTriggerer.CUSTOM_ERROR: {
      yield put(message({
        type: MESSAGE_TYPES.ERROR,
        errorCode: 'CustomError',
        errorDetails: {
          title: 'Custom title',
          buttontext: 'CustomBtnTxt',
          message: 'Custom message',
        }
      }))
      break
    }
    case popupTriggerer.SOUND_PROMPT: {
      yield put(message({
        type: MESSAGE_TYPES.SOUND_PROMPT,
        noCloseButton: true
      }))
      break
    }
    case popupTriggerer.GAME_RESTORE: {
      yield put(message({
        type: MESSAGE_TYPES.GAME_RESTORE
      }))
      break
    }
    case popupTriggerer.HOME_PROMPT: {
      yield put(message({
        type: MESSAGE_TYPES.HOME_PROMPT,
        noCloseButton: true
      }))
      break
    }
    case popupTriggerer.REALITY_CHECK: {
      const session = yield select(state => state.session)
      session.realityCheck = {
        totalSessionMinutes: 123,
        betSum: 1000,
        winSum: 5000,
        result: 4000,
      }
      session.rchistoryurl = 'http://www.google.com'
      yield put(message({
        type: MESSAGE_TYPES.REALITYCHECK,
        noCloseButton: true
      }))
      break
    }
    case popupTriggerer.QUICK_SPIN: {
      yield put(message({
        type: MESSAGE_TYPES.QUICKSPIN_PROMPT
      }))
      break
    }
    case popupTriggerer.MESSAGE_WITH_LOGIN: {
      yield put(message({
        message: 'Error message with login button',
        errorCode: 'Error code e.g. 305',
        type: MESSAGE_TYPES.MESSAGE_LOGIN
      }))
      break
    }
    case popupTriggerer.JACKPOT_WON: {
      yield put(message({
        type: MESSAGE_TYPES.JACKPOT,
        data: { lastWin: { amount: 400000 } },
        onClose: jackpotMessageClosed,
      }))
      break
    }
    case popupTriggerer.FREE_ROUNDS: {
      yield put(message({
        type: MESSAGE_TYPES.FREEROUNDS,
        data: {
          ba: 1000,
          spins: 20,
          type: 'money',
        }
      }))
      break
    }
    case popupTriggerer.FREE_ROUNDS_END: {
      yield put(message({
        type: MESSAGE_TYPES.FREEROUNDS,
        data: {
          ba: 1000,
          spins: 20,
          spinsended: true,
          type: 'money',
        }
      }))
      break
    }
    case popupTriggerer.FREE_ROUNDS_V2: {
      yield put(message({
        type: MESSAGE_TYPES.FREEROUNDS,
        data: {
          betSizeOptions: [
            { ba: 10, spins: 50 },
            { ba: 20, spins: 40 },
            { ba: 30, spins: 30 },
            { ba: 40, spins: 20 },
            { ba: 50, spins: 10 },
          ],
          type: 'money',
        }
      }))
      break
    }
    default: {
      break
    }
  }
}
